// import { FC } from 'react';
// import { TextField } from '@/components/form/fields';
// import { TProductForm } from './product-form.component';
// export const ProductNameSelector: FC = () => {
//     return (
//         <TextField<TProductForm>
//             name={'name'}
//             label={'Name'}
//             placeholder={'Enter product name'}
//             required
//         />
//     );
// };
//
//
import {
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from '@repo/shadcn';
import { useDebounce } from '@uidotdev/usehooks';
import { FC, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { AutoCompleteInput } from '../../../../components/ui/autocomplete/auto-complete-input';
import { useGetProductNameListQuery } from '../../../../features/slice/products/product/productApiSlice';
// import { useModal } from '../../../../hooks';
import { TProductForm } from './product-form.component';

export const ProductNameSelector: FC = () => {
    const [searchInputText, setSearchInputText] = useState('');
    // const { openModal } = useModal();

    const { setValue, watch, control } = useFormContext<TProductForm>();

    const selectedProductName = watch('name');
    const selectedProductNameId = watch('name_id');

    const debouncedSearchInputText = useDebounce(searchInputText, 500);

    const { data, isLoading, isFetching } = useGetProductNameListQuery({
        search: debouncedSearchInputText,
    });

    console.log('ProductNameSelector: data', data);

    const handleInputChange = (value: string) => {
        setSearchInputText(value);
        setValue('name_id', '');
        setValue('name', value);
    };

    const handleValueChange = (value: any) => {
        if (!value) {
            setValue('name', '');
            setValue('name_id', '');
            return;
        }

        setValue('name_id', value.value);
        setValue('name', value.label);
    };

    const generateOptions = () => {
        const options =
            data?.data.map((brand: any) => ({
                label: brand.name,
                value: brand.id,
            })) || [];

        // add selected option if not in the list
        if (
            selectedProductName &&
            selectedProductNameId &&
            !options.find((opt: any) => opt.value === selectedProductName)
        ) {
            options.unshift({
                label: selectedProductNameId,
                value: selectedProductName,
            });
        }

        return options;
    };

    const options = generateOptions();

    const selectedOption = {
        label: selectedProductNameId || '',
        value: selectedProductName || searchInputText || '',
    };

    return (
        <FormField
            control={control}
            name={'name_id'}
            render={() => (
                <FormItem>
                    <FormLabel className="flex items-center justify-between">
                        <div>
                            <span>Name</span>
                            <span className="ml-1 text-red-500">*</span>
                        </div>

                        {/*<Label
                            onClick={() =>
                                openModal(MODAL_ROUTE.CREATE_PRODUCT_BRAND)
                            }
                            className="flex cursor-pointer items-center gap-1 text-primary hover:underline"
                        >
                            <PiPlusCircleDuotone size={16} className="-mt-1" />
                            Select Product
                        </Label>*/}
                    </FormLabel>

                    <FormControl>
                        <AutoCompleteInput
                            clearOnBlur={false}
                            isLoading={isLoading || isFetching}
                            options={options}
                            showSuggestionsOnFocus={true}
                            value={selectedOption}
                            emptyMessage={'No items found'}
                            onValueChange={handleValueChange}
                            onInputChange={handleInputChange}
                        />
                    </FormControl>

                    <FormMessage className="line-clamp-1 text-xs" />
                </FormItem>
            )}
        />
    );
};

ProductNameSelector.displayName = 'ProductNameSelector';
